module.exports = __webpack_public_path__ + "img/camping.eff8a198.svg";